var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-downfile",on:{"click":function($event){return _vm.downfile()}}},[_vm._t("default",function(){return [(_vm.name)?_c('el-tag',[_vm._v(_vm._s(_vm.name))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }